import { PROPERTY_DATA_SOURCES } from 'legacyGraphQL/constants';
import PropertyAttributeValueContainer from 'legacy/containers/property-attribute-value';

import { PropertyDetailsSources as theme } from 'legacy/css-modules';

const PropertyDetailsSources = ({
  addressId,
  attributeGroups,
  dataHC,
  dataPR,
  dataMLS
}) => {
  return (
    <div>
      <div className={theme.AttributeGroupContainer}>
        {attributeGroups.map((group, g) => {
          return (
            <div
              key={`property-detail-src-group-${g}`}
              className={theme.AttributeGroup}
              style={{ flex: `1 1 ${100 / attributeGroups.length}%` }}
            >
              <div className={theme.AttributeGroupHeader}>
                <div className={theme.AttributeGroupHeaderLabel} />
                <div
                  data-hc-name="property-details-column-label"
                  className={theme.AttributeGroupHeaderLabel}
                >
                  HouseCanary
                </div>
                <div
                  data-hc-name="property-details-column-label"
                  className={theme.AttributeGroupHeaderLabel}
                >
                  MLS
                </div>
                <div
                  data-hc-name="property-details-column-label"
                  className={theme.AttributeGroupHeaderLabel}
                >
                  Public Record
                </div>
              </div>
              {group.map((attribute, a) => {
                if (!attribute) {
                  return null;
                }
                return (
                  <div
                    key={`property-detail-src-attribute-${g}-${a}`}
                    className={theme.Attribute}
                  >
                    <div
                      className={theme.AttributeLabel}
                      data-hc-name="property-details-all-sources-labels"
                    >
                      {attribute.label}
                    </div>
                    <div className={theme.AttributeValues}>
                      <div className={theme.AttributeHC}>
                        <PropertyAttributeValueContainer
                          addressId={addressId}
                          attrKey={attribute.key}
                          source={PROPERTY_DATA_SOURCES.HC}
                          property={dataHC}
                        />
                      </div>
                      <div className={theme.AttributeMLS}>
                        <PropertyAttributeValueContainer
                          addressId={addressId}
                          attrKey={attribute.key}
                          source={PROPERTY_DATA_SOURCES.MLS}
                          property={dataMLS}
                        />
                      </div>
                      <div className={theme.AttributePR}>
                        <PropertyAttributeValueContainer
                          addressId={addressId}
                          attrKey={attribute.key}
                          source={PROPERTY_DATA_SOURCES.PR}
                          property={dataPR}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PropertyDetailsSources;
